import { render, staticRenderFns } from "./video-details-info.vue?vue&type=template&id=0bacba12&scoped=true"
import script from "./video-details-info.vue?vue&type=script&lang=js"
export * from "./video-details-info.vue?vue&type=script&lang=js"
import style0 from "./video-details-info.vue?vue&type=style&index=0&id=0bacba12&prod&theme=dark-theater&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bacba12",
  null
  
)

export default component.exports